import React from "react";
import config from "../config/config";
import "../css/dashboard.css";
import "../css/orders.css";
import {
	Page,
	ButtonGroup,
	Button,
	Select,
	Card,
	Banner,
} from "@shopify/polaris";
import { RefreshMinor } from "@shopify/polaris-icons";
import { Row, Progress, Col } from "reactstrap";

import Analysis from "./Dashboard/Analysis";
import Credentials from "./Dashboard/Credentials";
import BannerHeader from "./Dashboard/BannerHeader";
import OrderTable from "./Orders/OrderTable";
import surveyImage from "../assets/survey_q1_2023.svg";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { DateUtils } from "react-day-picker";
import "react-day-picker/lib/style.css";

import dateFnsFormat from "date-fns/format";
import dateFnsParse from "date-fns/parse";
import pricingImg from "../assets/pricing/banner_pricing.svg";
// import createApp from "@shopify/app-bridge";
// import { Redirect } from "@shopify/app-bridge/actions";

import { connect } from "react-redux";
import {
	actFetchShowLoadingPage,
	actFetchDataStatistical,
	actFetchDataSettings,
} from "../actions/index";

import callApi from "../utils/apiCaller";
import TrackingStatus from "./Dashboard/TrackingStatus";
import Poll from "./Dashboard/Poll";
import RecommendedApps from "./recommended/RecommendedApps";
import IndependenceHoliday from "./feature/banners/IndependenceHoliday";
import { MobileCancelMajor } from "@shopify/polaris-icons";
import { Icon } from "@shopify/polaris";
const apiKey = config.apiKey;
const redirectUri = config.redirectUri;
const permissionUrl = `/oauth/authorize?client_id=${apiKey}&scope=read_orders&redirect_uri=${redirectUri}`;
var shopOrigin = config.shop;

function parseDate(str, format, locale) {
	const parsed = dateFnsParse(str, format, { locale });
	if (DateUtils.isDate(parsed)) {
		return parsed;
	}
	return undefined;
}

function formatDate(date, format, locale) {
	return dateFnsFormat(date, format, { locale });
}

function convertDate(inputFormat) {
	function pad(s) {
		return s < 10 ? "0" + s : s;
	}
	var d = new Date(inputFormat);
	return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join("/");
}

class Home extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			rangeSelected: "today",
			storeSelected: "all",
			selectedTimeRange: "this_month",
			messageLoading:
				"Please wait a few minutes for the system to get ORDERS from your shop ...",
			activeMenu: 1,
			optionListStore: [],
			dataStatistical: {},
			openTableStatus: false,
			notifyGetAllOrders: false,
			rangeFromDay: new Date(),
			rangeToDay: new Date(),
			isVisibleBanner: true,
		};
	}

	componentDidMount = async () => {
		await this.getDataProcessed("this_month", "all");
		await this.getData();
		await this.checkWebhook();
		// update banner holiday notice
		if (config.checkLocalStorage) {
			if (localStorage.getItem(config.shop + "-cancle-holiday-banner")) {
				this.setState({ isVisibleBanner: false });
			}
		}
	};

	getData = async () => {
		let params = {
			action: "getData",
		};
		callApi("get", params).then((res) => {
			this.props.fetchDataSettings(res.data.dataSettings);
		});
	};

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.listStore !== this.props.listStore) {
			if (this.props.listStore.length > 0) {
				let newOptionStore = [];
				let storeArr = [];
				for (let i = 0; i < this.props.listStore.length; i++) {
					let dataPush = {
						label: this.props.listStore[i].shop,
						value: this.props.listStore[i].shop,
					};
					newOptionStore.push(dataPush);
					storeArr.push(this.props.listStore[i].shop);
				}
				let dataPush = {
					label: "All Store",
					value: "all",
				};
				newOptionStore.push(dataPush);
				this.setState({ optionListStore: newOptionStore });
			}
		}
	}

	handleSelectChange = async (value) => {
		this.setState({ rangeSelected: value });
	};

	getDataProcessed = async (timeRange, store) => {
		this.setState({ storeSelected: store });
		this.setState({ selectedTimeRange: timeRange });
		if (timeRange !== "custom") {
			this.props.fetchShowLoadingPage(true);
			this.setState({ activeMenu: timeRange });
			var type = timeRange;
			let params = {
				action: "getDataProcessed",
				type: type,
				store: store,
				time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			};
			callApi("get", params).then((res) => {
				if (res.data.state === 0) {
					if (window.top === window.self) {
						window.location.assign(
							`https://${shopOrigin}/admin${permissionUrl}`
						);
					} else {
						// const url = new URL(`https://apps.synctrack.io${location.search}`);
						// const host = url.searchParams.get("host");
						// const app = createApp({
						//   apiKey: apiKey,
						//   host: host,
						//   forceRedirect: true,
						// });
						// Redirect.create(app).dispatch(
						//   Redirect.Action.ADMIN_PATH,
						//   permissionUrl
						// );
					}
				}

				this.setState({ dataStatistical: res.data });
				this.props.fetchDataStatistical(res.data);
				this.props.fetchShowLoadingPage(false);
			});
		}
	};

	checkWebhook = async () => {
		let params = {
			action: "checkWebhook",
		};
		callApi("get", params);
	};

	handleFromDayChange = (value) => {
		this.setState({ rangeFromDay: value });
	};

	handleToDayChange = (value) => {
		this.setState({ rangeToDay: value });
	};

	getDataProcessedRangeTime = async (value) => {
		this.setState({ activeMenu: value });
		let params = {
			action: "getDataProcessedRangeTime",
			from: convertDate(this.state.rangeFromDay),
			to: convertDate(this.state.rangeToDay),
			store: this.state.storeSelected,
		};
		callApi("get", params).then((res) => {
			console.log(res.data);
			this.props.fetchDataStatistical(res.data);
		});
	};

	getLinkAcceptScope = () => {
		let redirectUri =
			"https://apps.omegatheme.com/add-paypal-tracking/get_code.php?status=update_scope";
		let confirmationUrl =
			"https://" +
			config.shop +
			"/admin/oauth/request_grant?client_id=59855db23a211ce9ce602feeb5b798c3&redirect_uri=" +
			redirectUri +
			"&scope=read_orders, read_all_orders";
		window.top.location.replace(confirmationUrl);
	};

	// upload holiday notice banner
	handleRemoveBanner = () => {
		this.setState({
			isVisibleBanner: false,
		});
		localStorage.setItem(config.shop + "-cancle-holiday-banner", true);
		let paramsClick = {
			action: "clickReview",
			type: "20230430_holiday_notice",
			note: "hero_banner",
		};
		callApi("get", paramsClick);
	};

	render() {
		const optionsTimeRange = [
			{ label: "Today", value: "today" },
			{ label: "Yesterday", value: "yesterday" },
			{ label: "This month", value: "this_month" },
			{ label: "Last month", value: "last_month" },
			{ label: "Last 30 days", value: "30_days" },
			{ label: "Last 60 days", value: "60_days" },
			{ label: "Last 90 days", value: "90_days" },
			//   { label: "Custom", value: "custom" },
		];
		const FORMAT = "dd/MM/yyyy";
		return (
			<div fullWidth="true">
				<Row>
					{this.state.showLoadingPage ? (
						<div id="i_loading_page">
							<div
								className="loading_page_content"
								style={{ textAlign: "center" }}
							>
								<img
									src="https://linh.omegatheme.com/dev-better-search/admin/images/loading_cart.gif"
									alt="loading"
								/>
								<p className="mb-4">
									{this.state.messageLoading}
								</p>

								<Progress
									animated
									style={{
										height: "20px",
										margin: "auto",
										width: "75%",
									}}
									color="info"
									value={this.state.loadingValue}
									max="100"
								>
									{" "}
									{this.state.loadingValue}%{" "}
								</Progress>
							</div>
						</div>
					) : null}
				</Row>
				{this.state.isVisibleBanner && (
					<div style={{ marginBottom: "2rem", position: "relative" }}>
						<div
							className="banner-cancle-btn"
							onClick={this.handleRemoveBanner}
						>
							<Icon source={MobileCancelMajor} />
						</div>
						{/* <Banner status="info" title="Holiday notice">
							<div
								style={{
									display: "-webkit-box",
									flexWrap: "wrap",
								}}
							>
								<p>
									We are off to celebrate our Liberation Day
									from&nbsp;
								</p>
								<b>Apr 29 to May 3, 2023.&nbsp;</b>
								<p>We will only be able to provide&nbsp;</p>
								<b>
									limited support from 2-3 May, 5 PM - 8 AM
									(GMT +7 timezone).&nbsp;
								</b>
								<p>
									We will be back on May 4. Thank you for your
									kind patience!
								</p>
							</div>
						</Banner> */}
					</div>
				)}

				{/* <IndependenceHoliday /> */}
				<BannerHeader />
				{/* {config.platform !== "WOO_COMMERCE" ? <Poll /> : null} */}
				<Row>
					<Col md="12">
						<div className="mt-3 mb-3 d-flex float-right">
							<div className="mr-2">
								<Button
									onClick={() =>
										this.getDataProcessed(
											this.state.selectedTimeRange,
											this.state.storeSelected
										)
									}
									icon={RefreshMinor}
								></Button>
							</div>
							{this.state.optionListStore.length > 2 ? (
								<Select
									label="Store: "
									labelInline
									options={this.state.optionListStore}
									onChange={(value) =>
										this.getDataProcessed(
											this.state.selectedTimeRange,
											value
										)
									}
									value={this.state.storeSelected}
								/>
							) : null}
							<Select
								label="Time range: "
								labelInline
								options={optionsTimeRange}
								onChange={(value) =>
									this.getDataProcessed(
										value,
										this.state.storeSelected
									)
								}
								value={this.state.selectedTimeRange}
							/>
							{/* {this.state.selectedTimeRange === "custom" ? (
                                <div className="ml-3 dashboard-filter-bar-range">
                                    <ButtonGroup segmented>
                                        <Button
                                            primary={
                                                this.state.activeMenu === 5
                                                    ? true
                                                    : false
                                            }
                                        >
                                            From
                                        </Button>
                                        <DayPickerInput
                                            formatDate={formatDate}
                                            format={FORMAT}
                                            parseDate={parseDate}
                                            placeholder={`${dateFnsFormat(
                                                new Date(),
                                                FORMAT,
                                            )}`}
                                            onDayChange={
                                                this.handleFromDayChange
                                            }
                                            dayPickerProps={{
                                                modifiers: {
                                                    highlighted:
                                                        this.state.rangeFromDay,
                                                    disabled: [
                                                        {
                                                            after: this.state
                                                                .rangeToDay,
                                                        },
                                                    ],
                                                },
                                            }}
                                        />
                                        <Button
                                            primary={
                                                this.state.activeMenu === 5
                                                    ? true
                                                    : false
                                            }
                                        >
                                            To
                                        </Button>
                                        <DayPickerInput
                                            selectedDays={this.state.rangeToDay}
                                            formatDate={formatDate}
                                            format={FORMAT}
                                            parseDate={parseDate}
                                            placeholder={`${dateFnsFormat(
                                                new Date(),
                                                FORMAT,
                                            )}`}
                                            onDayChange={this.handleToDayChange}
                                            dayPickerProps={{
                                                modifiers: {
                                                    highlighted:
                                                        this.state.rangeToDay,
                                                    disabled: [
                                                        {
                                                            after: new Date(),
                                                            before: this.state
                                                                .rangeFromDay,
                                                        },
                                                    ],
                                                },
                                            }}
                                        />
                                        <Button
                                            primary={
                                                this.state.activeMenu === 5
                                                    ? true
                                                    : false
                                            }
                                            onClick={() =>
                                                this.getDataProcessedRangeTime(
                                                    5,
                                                )
                                            }
                                        >
                                            Get data
                                        </Button>
                                    </ButtonGroup>
                                </div>
                            ) : null} */}
						</div>
					</Col>
				</Row>
				<Analysis />
				{/* <IndicatorFilter /> */}
				<TrackingStatus />
				<Credentials
					storeSelected={this.state.storeSelected}
					openPlanTable={this.state.openTableStatus}
				/>
				<div className="mt-4">
					<Card sectioned title="Latest orders">
						<OrderTable
							storeSelected={this.state.storeSelected}
							type="latest"
						/>
					</Card>
				</div>
				{config.platform !== "WOO_COMMERCE" ? (
					<div className="app-recommended">
						<RecommendedApps />
					</div>
				) : null}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		dataSettings: state.dataSettings,
		dataStatistical: state.dataStatistical,
		listStore: state.listStore,
	};
};

const mapDispatchToProps = (dispatch, props) => {
	return {
		fetchShowLoadingPage: (showLoadingPage) => {
			dispatch(actFetchShowLoadingPage(showLoadingPage));
		},
		fetchDataSettings: (dataSettings) => {
			dispatch(actFetchDataSettings(dataSettings));
		},
		fetchDataStatistical: (dataStatistical) => {
			dispatch(actFetchDataStatistical(dataStatistical));
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
